import React from "react";
import { Card, Tabs } from "antd";
import { IssuesCloseOutlined } from "@ant-design/icons";
import { defaultSettings } from "css/defaultAntStyles";

import MyBtnConfirm from "Components/MyBtnConfirm/MyBtnConfirm";
import { TitleProjectStep } from "Pages/CreateProjectPage/components/TitleProjectStep/TitleProjectStep";
import { UserStep } from "Pages/CreateProjectPage/components/UsersStep/UserStep";
import { WorksStep } from "Pages/CreateProjectPage/components/WorksStep/WorksStep";
import { useDispatch, useSelector } from "react-redux";
import {
  selectProject,
  setAllowedWorkType,
  setChangeAccountNumber,
  setChangeGroup,
  setChangePlannedValue,
  setChangeUsers,
  setCreateGroup,
  setDeleteAllowedWork,
  setDeleteGroup,
  setIsParamsChanged,
  setTitle,
  updateProjectThunk,
} from "AppStore/Slices/ProjectSlice/ProjectSlice";
import { selectUser } from "AppStore/Slices/UserSlice/UserSlice";

export const SettingsWrapper = ({ disabled = false }) => {
  const {
    title,
    isSomeProjectValuesChanged,
    projectGroups,
    workTypes,
    users,
    isLoading,
    accountNumber,
  } = useSelector(selectProject);

  const { allRoles } = useSelector(selectUser);
  const dispatch = useDispatch();
  const changeParams = (param, value) => {
    dispatch(setIsParamsChanged());
    switch (param) {
      case "title":
        dispatch(setTitle(value));
        break;
      case "groupCreate":
        dispatch(setCreateGroup(value));
        break;
      case "deleteGroup":
        dispatch(setDeleteGroup(value));
        break;
      case "deleteAllowedWorkTypes":
        dispatch(setDeleteAllowedWork(value));
        break;
      case "changePlannedValue":
        dispatch(setChangePlannedValue(value));
        break;
      case "addAllowedWorkType":
        dispatch(setAllowedWorkType(value));
        break;
      case "changeGroup":
        dispatch(setChangeGroup(value));
        break;
      case "changeUsers":
        dispatch(setChangeUsers(value));
        break;
      case "accountNumber":
        dispatch(setChangeAccountNumber(value));
        break;
      default:
        break;
    }
  };
  const items = [
    {
      key: "global",
      label: "Загальні",
      children: (
        <TitleProjectStep
          accountNumber={accountNumber}
          disabled={disabled}
          title="Змінити назву та номер 1С замовлення проекту "
          size=""
          value={title}
          onChange={changeParams}
        />
      ),
    },
    {
      key: "works",
      label: "Керування роботами",
      children: (
        <WorksStep
          disabled={disabled}
          onChange={changeParams}
          groups={projectGroups}
          selectedWorks={workTypes}
        />
      ),
    },
    {
      key: "users",
      label: "Керування доступами",
      children: (
        <UserStep
          disabled={disabled}
          users={users}
          onChange={(params) => changeParams("changeUsers", params)}
          roles={allRoles}
        />
      ),
    },
  ];
  return (
    <>
      <Card style={{ borderRadius: 16 }}>
        <Card
          style={{
            borderRadius: 16,
            textAlign: "right",
            margin: "-20px",
            padding: 0,
            border: "none",
          }}
        >
          {isSomeProjectValuesChanged && !disabled && (
            <MyBtnConfirm
              isLoading={isLoading}
              textBtn="Зберегти всі зміни"
              mainTitle="Зберегти всі зміни?"
              onConfirm={() => {
                dispatch(updateProjectThunk());
              }}
              icon={
                <IssuesCloseOutlined
                  style={{
                    color: defaultSettings.colorPrimary,
                    fontSize: "30px",
                  }}
                />
              }
            />
          )}
        </Card>
        <Tabs defaultActiveKey="global" items={items} />
      </Card>
    </>
  );
};
